/**
 * 分销商管理 通用API
 */
import { post, get } from '../config/$ajax';
import { getErpHost } from '@/utils/domainHelper.js';

const API_HOST = getErpHost();

export const getAjax = (url, data = {}, params = {}) => {
  return get(API_HOST + url, data, params);
};

export const postAjax = (url, data = {}, params = {}) => {
  return post(API_HOST + url, data, params);
};


// 查询佣金规则
export const queryCommissionLevel = (data = {}, params = {}) => {
  return postAjax('dms/queryCommissionLevel', data, params)
}

// 修改佣金等级
export const updateCommissionLevel = (data = {}) => {
  return postAjax('dms/updateCommissionLevel', data, { submitType: 'json' })
}
export const queryDefaultPriceRule = (data = {}, params = {}) => {
  return getAjax('dms/queryDefaultPriceRule', data, params)
}

// 保存默认分销价
export const optDefaultPriceRule = (data = {}) => {
  return postAjax('dms/optDefaultPriceRule', data, { submitType: 'json' })
}

// 修改分销价，管控价
export const updateSinglePrice = (data = {}) => {
  return postAjax('dms/updateSinglePrice', data, { submitType: 'json' })
}

// 批量修改
export const batchUpdatePrice = (data = {}) => {
  return postAjax('dms/batchUpdatePrice', data, { submitType: 'json' })
}

// 批量修改佣金
export const batchUpdateCommission = (data = {}) => { 
  return postAjax('dms/batchUpdateCommission', data, { submitType: 'json' })
}

// 批量清空分销价默认折扣率
export const batchCancelDefDiscount = (data = {}) => { 
  return postAjax('dms/item/price/cancelDefDiscount', data, { submitType: 'json' })
}

// 批量清空佣金默认折扣率
export const batchCancelCommissionDefDiscount = (data = {}) => { 
  return postAjax('dms/cancelCommissionDefDiscount', data, { submitType: 'json' })
}

// 批量取消-商品等级分销价(中)
export const batchPriceCancel = (data = {}) => {
  return postAjax('/dms/item/price/cancel', data, { submitType: 'json' })
}

// 修改佣金-商品等级分销价(中)
export const updateSingleCommission = (data = {}) => {
  return postAjax('/dms/updateSingleCommission', data, { submitType: 'json' })
}
export const queryItemPricePageList = (data = {}) => {
  return getAjax('dms/queryItemPricePageList', data)
}
export const queryPostItemPricePageList = (data = {}) => {
  return postAjax('dms/queryItemPricePageListV2', data, { submitType: 'json' })
}
// 分销商规则-是否开启自动导入
export const getAutoImportItemsToKmt = (data = {}) => {
  return getAjax('item/config/getAutoImportItemsToKmt', data)
}
// 分销商规则-开启自动导入
export const updateAutoImportItemsToKmt = (data = {}) => {
  return postAjax('item/config/updateAutoImportItemsToKmt', data)
}

// 获取分销商列表
export const queryPriceRulePageList = (data = {}) => {
  return postAjax('dms/queryPriceRulePageListV2', data, { submitType: 'json' })
}

export const optPriceRule = (data = {}) => {
  return postAjax('dms/optPriceRule', data, { submitType: 'json' })
}

export const queryPriceRuleDetail = (data = {}) => {
  return getAjax('dms/queryPriceRuleDetail', data)
}

export const queryDistributorCompanyList = (data = {}) => {
  return getAjax('dms/queryDistributorCompanyList', data)
}

// 获取分销商列表
export const queryDistributorPageList = (data = {}, params = {}) => {
  return getAjax('dms/queryDistributorPageList', data, params).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
}

// 获取分销商列表（通用接口）
export const queryDistributorList = (data = {}, params = {}) => {
  return getAjax('dms/queryDistributorPageListV3', data, params).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
}

export const queryList = (data = {}) => {
  return getAjax('item/queryList', data)
}

export const queryListAll = (data = {}) => {
  return postAjax('item/list/all', data)
}

export const optItemRule = (data = {}) => {
  return postAjax('dms/optItemRule', data, {
    appJson: true,
    submitType: 'json',
  })
}

export const queryItemRulePageList = (data = {}) => {
  return getAjax('dms/querySCMItemRulePageList', data)
}
/**
 * 高级分销价展示设置
 * @param {*} data 
 * @param {*} params 
 * @returns 
 */
export const premiumDistributorPrice = (data = {}) => {
  return getAjax('dms/saveSetting', data)
}

export const queryItemDetail = (data = {},  params = {}) => {
  return postAjax('dms/queryItemDetail', data, params)
}

export const queryBrandListAll = (data = {},  params = {}) => {
  return getAjax('item/brand/listAll', data, params)
}

export const queryPropertyClassify = (data = {},  params = {}) => {
  return getAjax('/item/queryPropertyClassify', data)
}

// 获取类目
export const getClassifyList = (params, config) => {
  return getAjax('/item/queryPropertyClassify', params, config).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
}

// 获取类目全路径
export const getCategoryAllPath = (params, config) => {
  config = {
    isNeedFailNotice: true,
    isNeedLoading: false,
    ...config,
  }
  return getAjax('item/category/queryAllPath', params, config);
}

export const queryAllPropertyClassify = (data = {},  params = {}) => {
  return getAjax('/item/queryAllPropertyClassify', data)
}
export const getCatList = (data = {},  params = {}) => {
  return getAjax('/item/cat/list', data, params)
}
export const reqDmsCategoryList = (data = {}, params = {}) => {
  return getAjax('dms/queryCategory', data, { isNeedLoading: false });
}
// 获取分销小店商品价格
export const reqDisDmsGoodsPrice = (data = {}) => {
  return postAjax('dms/queryScmItemPricePageList', data, {submitType: 'json', headers: { 'Content-Type':'application/json' } });
};

// ERP 商品档案 v2
export const queryErpItemV2 = (data = {}) => {
  return postAjax('item/queryListV2', data);
};
// 查询数量
export const queryErpItemV2Count = (data = {}) => {
  return postAjax('item/queryCount', data, { isNeedLoading: false });
};

// 按款查询
export const queryErpItemByStyle = (data = {}) => {
  return getAjax('item/queryItemForKmtImport', data);
}
// 异步查询其他信息 /item/queryItemV2Reference
export const queryErpItemV2Reference = (data = {}) => {
  return postAjax('item/queryItemV2Reference', data, { isNeedLoading: false });
};

// 修改销售价
export const editSellingPrice = (data = {},  params = {}) => {
  return getAjax('item/editSellingPrice', data, params)
}

export const exportDistributorPrice = (data = {}) => {
  return postAjax('dms/boolexport/distributorPrice', data, {
    appJson: true,
    submitType: 'json',
  })
}

// 价格明细导出
export const exportExcelDistributorPrice = (data = {}) => {
  return postAjax('dms/exportExcel/distributorPrice', data, {
    appJson: true,
    submitType: 'json',
  })
}
// 
export const progressDistributorPrice = (url,data = {}) => {
  return getAjax(url, data)
}


// 分销基础设置-- 获取
export const queryDmsCompanyInfo = (data = {}) => {
  return getAjax('dms/queryDmsCompanyInfo', data)
}
// 分销基础设置-- 保存
export const saveDmsSetting = (data = {}) => {
  return getAjax('dms/saveSetting', data)
}
// 交易配置 -- 获取
export const queryTradeConfig = () => {
  return getAjax('trade/config/new/query')
}
// 交易配置 -- 保存
export const saveTradeConfig = (data = {}) => {
  return postAjax('trade/config/new/update', data, {
    appJson: true,
    submitType: 'json',
  })
}

// 用户管理-获取验证码
export const gainIdentifyCode = (data = {}) => {
  return postAjax('account/gainIdentifyCode', data);
}
// 用户管理-验证验证码
export const checkIdentifyCode = (data = {}) => {
  return postAjax('account/checkIdentifyCode', data)
}
// 用户管理-保存手机号
export const saveCompanyInfo = (data = {}) => {
  return postAjax('account/updateCompanyInfo', data)
}

// 邀请快递助手分销商
export const getKdzsShareUrl = (data = {}) => {
  return getAjax('openapi/distribution/item/getKdzsShareUrl', data)
}

// 供销商管理-修改代发店铺
export const updateSupplierInfo = (data = {}) => {
  return postAjax('dms/updateSupplierInfo', data)
}
// 供销商管理-设置新授权的店铺默认勾选
export const updateAutoAppointInsteadShop = (data = {}) => {
  return postAjax('dms/updateAutoAppointInsteadShop', data)
}

// 导出分销商品规则里的商品
export const exportRuleGoods = (data = {}) => {
  return postAjax('/dms/itemDetail/export', data).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
}

// 获取商品标签
export const getItemTags = (params, config) => {
  return getAjax('item/tags/pages', params, {isNeedLoading: false, ...config}).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
};

// 获取列配置
export const getColumnConf= params => {
  return getAjax('dms/columnConf/getList', params, {isNeedLoading: false}).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
};

// 更新列配置
export const updateColumnConf= params => {
  return postAjax('dms/columnConf/update', params, {submitType: 'json'}).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
};

// 重置列配置
export const resetColumnConf= params => {
  return postAjax('dms/columnConf/updateToDefault', params).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
};

// 供分销对账列表
export const rctCenterList = params => {
  return postAjax('dms/rct/center/list', params, {submitType: 'json'}).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
};

// 获取结算日志
export const getSettlementLog= params => {
  return getAjax('dms/rct/center/settlementLog', params).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
};

// 批量结算
export const batchCreateSettlement = params => {
  return postAjax('dms/rct/center/create/settlement', params, {submitType: 'json'}).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
};

// 批量修改审核状态+结算状态
export const batchOptBillStatus = params => {
  return postAjax('dms/rct/center/batch/optStatement', params, {submitType: 'json'}).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
};

// 收款方式聚合
export const queryPaymentTypes = params => {
  return postAjax('dms/rct/center/queryPaymentTypeList', params, {submitType: 'json'}).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
};

// 新建快麦结算单
export const createKmBill = params => {
  return postAjax('dms/rct/center/create/km', params, {submitType: 'json'}).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
};

// 生成结算唯一码
export const generateSettleUniqueCode = (params, config) => {
  return getAjax('dms/rct/center/getRctCenterSettleUniqueCode', params, {isNeedLoading: false, ...config}).then(res => {
    return res.result == 1 ? res : Promise.reject(res);
  });
};


/* --- 商品控价管理-- start -----*/
export const queryDisPriceControlRuleList = (params, config) => {
  return postAjax('dms/price/control/queryDisPriceControlRuleList', params, { submitType: 'json', ...config }).then(res => {
    return res.result == 1 ? res : false;
  });
};

/* --- 查询分销控价详情 -----*/
export const queryDisPriceControlRuleDetail = (params, config) => {
  return postAjax('/dms/price/control/queryDisPriceControlRuleDetail', params, { submitType: 'json', ...config }).then(res => {
    return res.result == 1 ? res : false;
  });
};

/* --- 修改新增分销控价------*/
export const addOrEditPriceControlRule = (params, config) => {
  return postAjax('/dms/price/control/optDmsPriceControlRule', params, { submitType: 'json', ...config }).then(res => {
    return res.result == 1 ? res : false;
  });
};

/* --- 修改分销控价状态-----*/
export const optDmsPriceControlRule = (params, config) => {
  return postAjax('dms/price/control/optDmsPriceControlRule', params, { submitType: 'json', ...config }).then(res => {
    return res.result == 1 ? res : false;
  });
};

/* --- 导出分销控价商品-----*/
export const exportControlPriceItems = (params, config) => {
  return postAjax('dms/price/control/exportExcel/itemControlPrice', params, { submitType: 'json', ...config }).then(res => {
    return res.result == 1 ? res : false;
  });
};
/* --- 导入分销控价商品-----*/
export const importControlPriceItems = (params, config) => {
  return postAjax('dms/price/control/excelImport/controlPriceItem', params, { submitType: 'json', ...config }).then(res => {
    return res.result == 1 ? res : false;
  });
};
/* --- 获取导入进度以及获取数据-----*/
export const importProgress = (params, config) => {
  return getAjax('dms/progress/query', params, { ...config }).then(res => {
    return res.result == 1 ? res : false;
  });
};
/* --- 修改分销控价规则-----*/
export const updatePriceControlRule = (params, config) => {
  return postAjax('dms/price/control/updPriceControlRule', params, { submitType: 'json', ...config }).then(res => {
    return res.result == 1 ? res : false;
  });
};
/* --- 批量删除分销控价-----*/
export const batchDelPriceControlRule = (params, config) => {
  return postAjax('dms/price/control/batchDelPriceControlRule', params, { submitType: 'json', ...config }).then(res => {
    return res.result == 1 ? res : false;
  });
};





/* --- 商品控价管理--  end  -----*/